import axios from 'axios';
import { useState } from 'react';
import Swal from 'sweetalert2';
import ListarTarjetas from './ListarTarjetasAsignadas';

const RegistrarTarjetaAprendiz = () => {
    const [documentoAprendiz, setDocumentoAprendiz] = useState('');
    const [nombreAprendiz, setNombreAprendiz] = useState('');
    const [tarjetaUID, setTarjetaUID] = useState('');
    const [aprendizId, setAprendizId] = useState('');

    const saveTarjeta = async () => {
        if (!aprendizId || !tarjetaUID.trim()) {
            return Swal.fire({
                icon: 'warning',
                title: 'Campos incompletos',
                text: 'Debes verificar el documento y escribir el UID de la tarjeta.',
            });
        }

        try {
            const nuevaAsignacion = {
                aprendiz: aprendizId,
                tarjetaUID: tarjetaUID.trim()
            };

            await axios.post('/api/tarjetas/add', nuevaAsignacion);

            // Limpiar campos
            setDocumentoAprendiz('');
            setNombreAprendiz('');
            setTarjetaUID('');
            setAprendizId('');

            Swal.fire({
                icon: 'success',
                title: '¡Tarjeta asignada correctamente!',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error al asignar la tarjeta:', error);

            Swal.fire({
                icon: 'error',
                title: 'Error al asignar la tarjeta',
                text: error.response?.data?.message || 'Error desconocido',
            });
        }
    };

    const actions = async (e) => {
        e.preventDefault();
        await saveTarjeta();
    };

    const verificarDocumentoAprendiz = async (documento) => {
        if (!documento) return;

        try {
            const response = await axios.get(`/api/aprendices/verificar/${documento}`);
            console.log('Respuesta backend:', response.data);

            if (response.data.exists) {
                setNombreAprendiz(response.data.nombreCompleto);
                setAprendizId(response.data.aprendizId); // ✅ Correcto
            } else {
                setNombreAprendiz('');
                setAprendizId('');
                Swal.fire({
                    icon: 'error',
                    title: 'Aprendiz no encontrado',
                    text: 'El documento ingresado no corresponde a ningún aprendiz.',
                });
            }
        } catch (error) {
            console.error('Error al verificar el documento del aprendiz:', error);
            setNombreAprendiz('');
            setAprendizId('');
            Swal.fire({
                icon: 'error',
                title: 'Error del servidor',
                text: 'No se pudo verificar el documento.',
            });
        }
    };

    const handleDocumentoAprendizChange = (e) => {
        setDocumentoAprendiz(e.target.value);
    };

    const handleDocumentoAprendizKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            verificarDocumentoAprendiz(documentoAprendiz);
        }
    };

    const handleDocumentoAprendizBlur = () => {
        verificarDocumentoAprendiz(documentoAprendiz);
    };

    return (
        <div>
            <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
                < div className='container-fluid mt-3' >
                    <h1>Asignar Tarjeta</h1>
                </div>

                <div className='mb-5'>

                    <form onSubmit={actions}>

                        <div className="container">

                            <div className="row mb-3">
                                {/* Documento Aprendiz */}
                                <div className="col-md-3">
                                    <label className="form-label">Documento Aprendiz</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Documento"
                                        value={documentoAprendiz}
                                        onChange={handleDocumentoAprendizChange}
                                        onBlur={handleDocumentoAprendizBlur}
                                        onKeyDown={handleDocumentoAprendizKeyDown}
                                        required
                                    />
                                </div>

                                {/* Nombre Aprendiz */}
                                <div className="col-md-6">
                                    <label className="form-label">Nombre Aprendiz</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre completo"
                                        value={nombreAprendiz}
                                        readOnly
                                        disabled
                                    />
                                </div>
                                {/* UID de Tarjeta */}
                                <div className="col-md-3">
                                    <label className="form-label">UID de la Tarjeta</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="UID de la tarjeta RFID"
                                        value={tarjetaUID}
                                        onChange={(e) => setTarjetaUID(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Botón de envío */}
                            <div className="col-12 mt-4 mb-5">
                                <div className="row">
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-success w-100">
                                            Asignar Tarjeta
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div>
                <ListarTarjetas />
            </div>
        </div>

    );
};

export default RegistrarTarjetaAprendiz;
